import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeeColumnFilterPanelService } from './services/fee-column-filter-panel.service';
import { Subscription } from 'rxjs/Subscription';
import { CommonService } from './services';
import { filter, take, ProgramsBillingType, AutoUnsubscribe, StorageUtil, switchMap } from './models';
import { NotificationsService } from 'angular2-notifications';
import { Store, AppState, AppFields, AppTypes } from './store';
import {
  Router,
  ActivatedRoute,
  NavigationStart,
  NavigationEnd,
  RouterOutlet
} from '@angular/router';
import { MyTeamsService } from './services/my-teams.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
@AutoUnsubscribe
export class AppComponent implements OnInit {
  template = `<div class="page-loader"><img src="assets/img/loading.gif" /></div>`;
  threshold = 10;
  timeout = 8000000;

  isToggleClubFeeFilterPanel = false;
  title = 'app';
  message: string;
  subscription: Subscription;

  notifyOptions = {
    timeOut: 3000,
    pauseOnHover: false,
    clickToClose: false,
    position: ['top', 'right']
  };

  public programId: number;
  public programTypeId: number;
  public programName: string;
  public programStatus: string;

  public isUserAuthenticated: boolean = true;

  constructor(
    private feeColumnFilterPanelService: FeeColumnFilterPanelService,
    private commonService: CommonService,
    private notificationService: NotificationsService,
    private store: Store<AppState>,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.programId = 2237;
    this.programTypeId = 1;
    this.programName = 'program 1';
    this.programStatus = 'active';

    this.router.events.subscribe(r => {
      if (r instanceof NavigationEnd) {
        if (r.url === '/401' || router.url.startsWith('/video-promotion') || router.url.startsWith('/auth/')) {
          this.isUserAuthenticated = false;
        } else {
          this.isUserAuthenticated = true;
        }
      }
      window.scrollTo(0, 0);
    });

    this.store
      .select(AppFields.App, AppFields.User)
      .pipe(take(1))
      .subscribe(
        u =>
          u === null &&
          this.store.dispatch({
            type: AppTypes.ValidateUser
          })
      );
  }

  ngOnInit() {
    // subscribe to ClubProgramFeeReadComponent
    this.subscription = this.feeColumnFilterPanelService
      .getToggleFilterColumnsPanel()
      .subscribe(da => {
        this.isToggleClubFeeFilterPanel = da;
      });

    this.subscription.add(
      this.commonService.alert.pipe(filter(a => !!a)).subscribe(alert => {
        this.notificationService.html(
          alert.message,
          alert.type as any,
          alert.options
        );
      })
    );

    this.subscription.add(
      this.store.select(AppFields.App, AppFields.Club).subscribe(
        club =>
          club === null && localStorage.getItem('clubId') &&
          this.store.dispatch({
            type: AppTypes.InitializeClub,
            payload: { clubId: localStorage.getItem('clubId') }
          })
      )
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts